"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderEmiCardClickDL } from "./HeaderAnalyticsFunction";

interface HeaderEMICardProps {
  headerEMICard?: {
    ctaInNewTab: string;
    ctaLink: string;
    heading: string;
    isActiveClass: string;
    key: string;
    sectionID: string;
    showOnApp: string;
    showOnWeb: string;
    template: string;
  };
}

const EMICard: React.FC<HeaderEMICardProps> = ({ headerEMICard }) => {
  return (
    <BFLLink
      href={headerEMICard?.ctaLink}
      openInNewTab={headerEMICard?.ctaInNewTab}
      onClick={() => handleHeaderEmiCardClickDL()}
      className="order-3 m-0 flex flex-col items-center px-2 pb-[30px] pt-[14px] hover:bg-[#001326] md:order-2"
    >
      <i className="icomoon text-2xl before:content-['\e955']"></i>
      <span className="hidden whitespace-nowrap text-xs leading-[14px] md:!block">
        {headerEMICard?.heading ?? ""}
      </span>
    </BFLLink>
  );
};
export default EMICard;
